import { Link, useNavigate } from 'react-router-dom';
import LogoutSVG from 'src/assets/images/icons/LogoutSVG';
import { useAuthCookies } from '../../hooks/cookie-helper';
interface SalesScriptHeaderProps {
	title: string;
}

const SalesScriptHeader: React.FC<SalesScriptHeaderProps> = ({ title }) => {
	const { removeAccessToken } = useAuthCookies();
	const navigate = useNavigate();
	const handleLogout = (action: string) => {
		if (action === 'logout') {
			localStorage.clear();
			removeAccessToken();
			navigate('/login');
			console.log('logout button clicked');
		}
	};
	return (
		<div className="mb-6 flex justify-between items-center">
			<h2 className="m-0 text-2xl font-bold text-gray-700">{title}</h2>
			<div className="flex space-x-4 items-center">
				<Link to="/" className="border border-gray-600 text-[14px] font-semibold py-1.5 px-2 rounded">
					Gen AI Studio
				</Link>
				<button
					type="button"
					title="logout"
					onClick={() => handleLogout('logout')}
					className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f8c246] hover:bg-[#f8c246] focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-1 focus-visible:outline-[#f8c246]"
				>
					<LogoutSVG />
				</button>
			</div>
		</div>
	);
};

export default SalesScriptHeader;
